export default [
  {
    path: "/fleet/provider",
    name: "Provider",
    component: () => import("@/components/master/provider/Provider"),
    meta: {
      title: "Provider",
      requiresAuth: true,
      services: ["Provider"]
    }
  },
  {
    path: "/fleet/driver",
    name: "Driver",
    component: () => import("@/components/master/driver/Driver"),
    meta: {
      title: "Driver",
      requiresAuth: true,
      services: ["Driver"]
    }
  },
  {
    path: "/fleet/driver-tracker",
    name: "DriverTracker",
    component: () => import("@/components/tracker/index"),
    meta: {
      title: "Driver Tracker",
      requiresAuth: true,
      services: ["Driver"]
    }
  },
  {
    path: "/fleet/vehicle",
    name: "Vehicle",
    component: () => import("@/components/master/vehicle/Vehicle"),
    meta: {
      title: "Vehicle",
      requiresAuth: true,
      services: ["Vehicle"]
    }
  },
  {
    path: "/fleet/class",
    name: "MasterClass",
    component: () => import("@/components/master/class/MasterClass"),
    meta: {
      title: "Master Class",
      requiresAuth: true,
      services: ["MasterClass"]
    }
  },
  {
    path: "/fleet/maintenance",
    name: "VehicleRepairement",
    component: () =>
      import("@/components/master/repairement/VehicleMaintenance"),
    meta: {
      title: "Vehicle Maintenance",
      requiresAuth: true,
      services: ["VehicleRepairement"]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/fleetMasterModule.js